import { z } from "zod";
export const CursorPaginationQuery = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const cursorPaginationResponse = (item) => z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
});
